import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'dateTimeFormat',
  pure: true,
  standalone: true
})
export class DateTimeFormatPipe implements PipeTransform {
  transform(
    value: Date | string | null | undefined,
    format = 'DD/MM/YYYY HH:mm'
  ): string {
    if (!value) return '-';
    return dayjs(value).format(format);
  }
}
